module.exports = __webpack_public_path__ + "img/attribute_mark_2_off.5847781.png";